module.exports = __webpack_public_path__ + "img/ayun-apps.aefafc4d.png";